var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component"},[_vm._t("default",null,{"collection":_vm.dataSource,"model":_vm.model,"schema":_vm.schema,"schemas":_vm.schemas,"count":_vm.count})],2)}
var staticRenderFns = []

export { render, staticRenderFns }